/**
 * 小程序 预览图管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>图片发布</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 标签页 -->
    <div style="margin-bottom: 20px;">

    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">

      <el-tab-pane label="缩略图" name="first">
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" ref="formInline" class="user-search">
          <el-form-item label="搜索：" prop="description">
            <el-input size="small" v-model="formInline.description" placeholder="输入主题"></el-input>
          </el-form-item>
          <el-form-item prop="type">
            <el-select size="small" style="width: 140px" clearable v-model="formInline.type" placeholder="图片类别">
              <el-option v-for="type in types" :label="type.typename" :value="type.typeno" :key="type.typeno"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="isdelete">
            <el-select size="small" style="width: 100px" clearable v-model="formInline.isdelete" placeholder="是否删除">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="authorization">
            <el-select size="small" style="width: 120px" clearable v-model="formInline.authorization" placeholder="是否有水印权限">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="isprivate">
            <el-select size="small" style="width: 120px" clearable v-model="formInline.isprivate" placeholder="是否私密图片">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="sortno">
            <el-input size="small" type="number" style="width: 130px" clearable v-model="formInline.sortno" placeholder="输入排序码（数字）"></el-input>
          </el-form-item>
          <el-form-item label="" prop="date_time">
            <el-date-picker
              v-model="formInline.date_time"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
               style="width: 260px"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="resetForm('formInline')">重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
          </el-form-item>
        </el-form>

        <!-- 数据列表 -->
        <el-row>
          <el-col :span="4" v-for="(item, index) in listData" :key="index">
            <el-card :body-style="{ padding: '0px',position: 'relative'}">
              <el-image style="height: 200px" :src="item.path" fit="cover" :preview-src-list="item.subUrl">
              </el-image>
              <div style="padding: 14px;box-sizing:border-box;height:60px;">
                <el-tooltip class="item" effect="dark" :content="item.description" placement="top-start">
                  <span>{{item.description}}</span>
                </el-tooltip>
              </div>
              <div class="linkDiv1" style="background-color: black;height: 40px;padding: 0;opacity: .5;">
              </div>
              <div class="linkDiv">
                <el-link type="success" @click="handleEdit(index,item)" class="ellink" >编辑</el-link>
                &nbsp;&nbsp;
                <el-link type="success" @click="linkDetail(index,item)" class="ellink" >组图({{item.subUrl.length}})</el-link>
              </div>
            </el-card>
          </el-col>
        </el-row>

      </el-tab-pane>

      <el-tab-pane label="详情图片" name="second">
        <PictureList :pid="this.tid"></PictureList>
      </el-tab-pane>

    </el-tabs>
  
    <!-- 分页组件 -->
    <div id="pagemodal" v-if="activeName=='first'">
      <Pagination agination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="主键..." v-if="false">
          <el-input  v-model="editForm.tid" auto-complete="off"></el-input>
          <el-input  v-model="editForm.name" auto-complete="off"></el-input>
          <el-input  v-model="editForm.suffix" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="false" prop="newid">
          <el-input  v-model="editForm.newid" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="description">
          <el-input type="textarea" size="small" v-model="editForm.description" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="图片类别" prop="type">
          <el-select size="small" v-model="editForm.type"  placeholder="请选择图片类别">
            <el-option v-for="type in types" :label="type.typename" :value="type.typeno" :key="type.typeno"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否水印授权" prop="authorization">
          <el-radio v-model="editForm.authorization" label="1">是</el-radio>
          <el-radio v-model="editForm.authorization" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="是否私密图片" prop="isprivate">
          <el-radio v-model="editForm.isprivate" label="1">是</el-radio>
          <el-radio v-model="editForm.isprivate" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="图片密码" prop="passwd" v-if="editForm.isprivate==1">
          <el-input size="small" v-model="editForm.passwd" auto-complete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="排序码" prop="sortno">
          <el-input size="small" type="number" v-model="editForm.sortno" auto-complete="off" placeholder="请输入数字排序码"></el-input>
        </el-form-item>
        <el-form-item label="是否删除" prop="isdelete">
          <el-radio v-model="editForm.isdelete" label="1">是</el-radio>
          <el-radio v-model="editForm.isdelete" label="0">否</el-radio>
        </el-form-item>

        <el-form-item label="图片大小" prop="size">
          <el-input size="small" v-model="editForm.size"  disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片宽度" prop="picwidth">
          <el-input size="small" v-model="editForm.picwidth" disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片高度" prop="picheight">
          <el-input size="small" v-model="editForm.picheight"  disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="上传者id" prop="uploaderid">
          <el-input size="small" v-model="editForm.uploaderid"  disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="上传时间" prop="createtime">
          <el-input size="small" v-model="editForm.createtime"  disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="预览图片" prop="path">
          
          <template v-if="title == '修改'">
            <el-image style=" width: 100px" :src="editForm.path" :preview-src-list="[editForm.path]">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        
        </el-form-item>
        <el-form-item label="更新图片" prop="path">

          <el-upload
            class="avatar-uploader"
            :action="fileUploadAction"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :data="this.uploadData"
            :before-upload="beforeAvatarUpload">
            <img v-if="editForm.path" :src="editForm.path " class="avatar">
            <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ThumbnailList, ThumbnailSave,ThumbnailUpload } from '../../api/businessMG'
import PictureList from './PictureList.vue'
import { WxSelTypes } from '../../api/basisMG'
import Pagination from '../../components/Pagination'
import {dateFormat} from '../../utils/datetime'
export default {
  data() {
    return {
      activeName: 'first',//当前显示的标签name

      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      user:{},
      uploadData:{name:'test上传'},
      imageUrl: '',
      tid: '',//点击时的预览图ID
      title: '添加',
      editForm: {
        tid: '',
        description: '',
        type: '',
        path: '',
        size: '',
        picwidth: '',
        picheight: '',
        uploaderid: '',
        createtime:'',
        isdelete: '',
        sortno: '',
        authorization: '',
        isprivate: '',
        passwd: '',
        name:'',
        suffix:'',
        newid: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        description: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        type: [{ required: true, message: '请选择图片类型', trigger: 'blur' }],
        sortno: [{ required: true, message: '请输入排序码', trigger: 'blur' }],
        passwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        path: [{ required: true, message: '请选择一个图片', trigger: 'blur' }],
        
      },
      formInline: {
        page: 1,
        limit: 30,
        description: '',
        type:'',
        isdelete: '0',
        sortno:'',
        authorization:'',
        isprivate:'',
        startTime: '',
        endTime: '',
        date_time:[],
        Token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      types:[],
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 30,
        total: 10
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  // 注册组件
  components: {
    Pagination,
    PictureList
  },
  /**
   * 数据发生改变
   */
  computed: {
    fileUploadAction() {
      return ThumbnailUpload()
    },
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.user = JSON.parse(localStorage.getItem('userdata'))
    //初始化权限等级下拉
    WxSelTypes({}).then(res => {
      if (res.result != 'success') {
        this.$message({
          type: 'info',
          message: '图片分类请求失败'
        })
      } else {
        this.types = res.list
      }
    })
    .catch(err => {
      this.types = [];
    })
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    
    // 获取数据列表
    getdata(parameter) {
      this.loading = true
      ThumbnailList(parameter)
        .then(res => {
          console.log(res)
          this.loading = false
          if (res.result != 'success') {
            this.$message({
              type: 'info',
              message: '请求失败'
            })
          } else {
            this.listData = res.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$message.error(err.response.statusText)
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      // this.$message({
      //   type: 'success',
      //   message: '这是一个小提示'
      // })
      //时间段为空，则开始和结束时间都为空
      if(this.formInline.date_time[0]) {

        this.formInline.startTime = this.formInline.date_time[0]
      }else{
        this.formInline.startTime = ''
      }
      if(this.formInline.date_time[1]) {
        this.formInline.endTime = this.formInline.date_time[1]
        
      }else{
        this.formInline.endTime = ''
      }
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    //重置
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },
    linkDetail: function(index, row) {
      this.tid = row.tid
      this.activeName = 'second';
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      console.log(this.editForm)
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.tid = row.tid
        this.editForm.description = row.description
        this.editForm.type = row.type
        this.editForm.path = row.path+'?'+Math.random()
        this.editForm.size = row.size
        this.editForm.picwidth = row.picwidth
        this.editForm.picheight = row.picheight
        this.editForm.uploaderid = row.uploaderid
        this.editForm.createtime = row.createtime
        this.editForm.isdelete = row.isdelete
        this.editForm.sortno = row.sortno
        this.editForm.authorization = row.authorization
        this.editForm.isprivate = row.isprivate
        this.editForm.passwd = row.passwd
        this.editForm.suffix = row.suffix
        this.editForm.name = row.name
        this.editForm.newid = '' //选了图片才不为空
      } else {
        this.title = '新增'
        this.editForm.tid = ''
        this.editForm.description = ''
        this.editForm.type = ''
        this.editForm.path = ''
        this.editForm.size = ''
        this.editForm.picwidth = ''
        this.editForm.picheight = ''
        this.editForm.uploaderid = this.user.username
        this.editForm.sortno = '1'
        this.editForm.authorization = '0'
        this.editForm.isprivate = '0'
        this.editForm.passwd = ''
        this.editForm.createtime = dateFormat(new Date())
        this.editForm.isdelete = '0'
        this.editForm.suffix = ''
        this.editForm.name = ''
        this.editForm.newid = '' //选了图片才不为空
      }
    },
    uploadSuccess(res, file){
      // console.log(res)
      // console.log(file)
      // this.imageUrl = URL.createObjectURL(file.raw);
      this.editForm.path = URL.createObjectURL(file.raw);
      this.editForm.suffix = res.suffix
      this.editForm.size = res.size
      this.editForm.picwidth = res.width
      this.editForm.picheight = res.height
      this.editForm.newid = res.fileName
      this.editForm.name = res.name
      this.editForm.createtime = dateFormat(new Date())
    },
    uploadError(err, file, fileList){
      this.$message.error('上传失败!'+err);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
      }
      return isJPG && isLt2M;
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // console.log(this.editForm)
          ThumbnailSave(this.editForm)
            .then(res => {
              console.log(res)
              this.editFormVisible = false
              this.loading = false
              if (res.result === 'success') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    handleClick(tab, event) {
      console.log(this.tid);
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>

.user-search {
  margin-top: 20;
}
.userRole {
  width: 100%;
}
.el-col {
    margin-left: 2%;
    margin-bottom: 10px;
  }
.el-tabs{
  margin-bottom: 30px;
} 
.el-card {
    min-width: 100%;
    height: 100%;
    background-color: #f8f8ff;
    /* margin-right: 20px;
    transition: all .5s; */
  }
.linkDiv1{
  position: absolute;
  background-color: black;
  height: 40px;
  width: 100%;
  top: 160px;
  padding: 0;
  opacity: .5;
}  
  /* 按钮父级 */
.linkDiv{
  line-height: 40px;
  width: 100%;
  height: 40px;
  top: 160px;
  position: absolute;
  text-align: center;
}  
  .ellink{
    font-size:16px;color:rgb(255, 255, 255);
  }
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
</style>



// WEBPACK FOOTER //
// src/views/miniBusiness/Thumbnail.vue